import React from 'react';
import { useNavigate } from 'react-router-dom';

import { Logo } from '@components/Logo';
import { Button } from '@components/ui/button';

const PageNotFound: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="flex h-screen items-center justify-center">
      <div className="flex max-w-[440px] flex-col items-center justify-center px-5 text-center">
        <Logo />
        <h2 className="mb-2 mt-10 text-lg font-bold text-foreground">
          We can&apos;t find the page you&apos;re looking for.
        </h2>
        <p className="mb-10 text-sm text-foreground">
          It may have been moved, renamed, or temporarily unavailable. Please
          check the URL or go back home.
        </p>
        <Button onClick={() => navigate('/auth')}>Go back home</Button>
      </div>
    </div>
  );
};

export default PageNotFound;
